import { render } from "./index.vue?vue&type=template&id=3c86ae02"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/brand-logo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c86ae02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c86ae02', __exports__)) {
    api.reload('3c86ae02', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3c86ae02", () => {
    api.rerender('3c86ae02', render)
  })

}


export default __exports__